import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { BLOG_FAQ } from "../data/blog";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section id="gyik" className="py-24 lg:py-32 bg-white">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-xs sm:text-sm uppercase tracking-widest font-bold text-sky-600 bg-sky-50 px-3 py-1 rounded-full inline-block mb-4 border border-sky-100">
            Gyakori kérdések
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900">
            Amit sokan <span className="text-sky-600">kérdeznek.</span>
          </h2>
        </div>

        <div className="space-y-3">
          {BLOG_FAQ.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={i} data-testid={`faq-item-${i}`} className="rounded-2xl border border-slate-200 overflow-hidden bg-slate-50/50">
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
                >
                  <span className="font-display font-bold text-slate-900 text-base sm:text-lg">{item.q}</span>
                  <span className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-colors ${isOpen ? "bg-sky-600 text-white" : "bg-white text-sky-600 border border-slate-200"}`}>
                    {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className="overflow-hidden"
                    >
                      <p className="px-6 pb-5 text-slate-600 leading-relaxed">{item.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
